@if (isInitialized$ | async) {
    @if (showSplashScreen()) {
        <app-splash-screen data-qa="splash-screen"/>
    } @else {
        <app-modals/>
        @if (isShowingAiChat()) {
            <app-ai-chat [isTabletSize]="!hasSmallViewport()" class="ai-chat-overlay"/>
        } @else if (isShowingHistoryOverlay()) {
            <app-history-overlay/>
        } @else if (isShowingSearchOverlay()) {
            <app-search-overview/>
        }
        <router-outlet/>
        @if (isTutorialEnabled()) {
            <app-tutorial [tutorialOptions]="tutorialOptions"/>
        }
    }

    @if (!isProduction && (showDebugMenu$ | async)) {
        <div class="debug-menu-wrapper">
            <app-debug-menu/>
        </div>
    }
}
